module.exports = __webpack_public_path__ + "img/blackout.5cbe0e29.png";